import Model from '@/models/Model'

export default class GCommune extends Model {
    resource() {
        return 'g_commune'
    }
}